import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
//Componentes Material
import { withStyles } from '@material-ui/core';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import FormHelperText from '@material-ui/core/FormHelperText';
//Icones
import AddIcon from '@material-ui/icons/Add';
import DeleteIcon from '@material-ui/icons/Delete';
import ArrowUpwardIcon from '@material-ui/icons/ArrowUpward';
import ArrowDownwardIcon from '@material-ui/icons/ArrowDownward';
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';
//Componentes
import VitalizePaper from '../VitalizePaper';
import Questao from './Questao';
import ConfirmDialog from '../ConfirmDialog';
//Úteis
import deepCopy from '../../utils/deepCopy';
//Modelos
import QuestionarioSecao from '../../models/QuestionarioSecao';
import QuestionarioQuestao from '../../models/QuestionarioQuestao';
import QuestionarioOpcaoResposta from '../../models/QuestionarioOpcaoResposta';
import ErroQuestionarioSecao from '../../models/ErroQuestionarioSecao';

const styles = (theme) => ({
    tituloSecao: {
        borderTopColor: theme.palette.primary.main,
        borderTopStyle: 'solid',
        borderTopWidth: '3px'
    }
});

/**
 * Componente para renderizar uma seção do questionário
 */
class Secao extends React.Component {
    constructor(props) {
        super(props);
        //Bindings
        this.handleChange = this.handleChange.bind(this);
        this.handleUpClick = this.handleUpClick.bind(this);
        this.handleDownClick = this.handleDownClick.bind(this);
        this.handleDeleteClick = this.handleDeleteClick.bind(this);
        this.handleOcultarClick = this.handleOcultarClick.bind(this);
        this.handleQuestaoChange = this.handleQuestaoChange.bind(this);
        this.handleQuestaoMoveUp = this.handleQuestaoMoveUp.bind(this);
        this.handleQuestaoMoveDown = this.handleQuestaoMoveDown.bind(this);
        this.handleAdicionarQuestao = this.handleAdicionarQuestao.bind(this);
        this.handleQuestaoDelete = this.handleQuestaoDelete.bind(this);
        this.handleDialogClose = this.handleDialogClose.bind(this);
        //Initial state
        this.state = {
            open: true,
            confirmarExclusao: false
        };
    }

    /**
     * Trata a alteração no campo de título da seção
     * @param {*} event Objeto com os dados do evento
     */
    handleChange(event) {
        //Copia a seção
        const secao = QuestionarioSecao.clone(this.props.secao);
        //Preenche o título com o valor recebido
        secao.titulo = event.target.value;
        //Dispara o evento de alteração
        this.dispararEventoOnChange(secao);
    }

    /**
     * Trata o click do botão de mover para cima
     */
    handleUpClick() {
        //Dispara o evento de movimentação
        this.dispararEventoOnMoveUp(this.props.secao);
    }

    /** Trata o click do botão de mover para baixo */
    handleDownClick() {
        //Dispara o evento de movimentação
        this.dispararEventoOnMoveDown(this.props.secao);
    }

    /**
     * Trata o click do botão de ocultar o corpo da seção
     */
    handleOcultarClick() {
        //Copia o estado do componente
        const state = deepCopy(this.state);
        //Alterna o estado
        state.open = !state.open;
        //Atualiza
        this.setState(state);
    }

    /**
     * Trata o click do botão de exclusão
     */
    handleDeleteClick() {
        //Caso tenha alguma alteração
        if (this.props.secao.titulo || this.props.secao.questoes.length > 0) {
            //Exibe o dialog de confirmação
            this.setState({ confirmarExclusao: true });
        } else {
            //Dispara o evento de exclusão
            this.dispararEventoOnDelete(this.props.secao);
        }
    }

    /**
     * Trata a alteração nos dados de uma questão
     * @param {QuestionarioQuestao} questao Objeto com os dados da questao
     */
    handleQuestaoChange(questao) {
        //Copia a seção
        const secao = QuestionarioSecao.clone(this.props.secao);
        //Identifica o índice da questão
        const indice = secao.questoes.findIndex(q => q.ordem === questao.ordem);
        //Atualiza o valor na lista
        secao.questoes[indice] = questao;
        //Dispara o evento de alteração
        this.dispararEventoOnChange(secao);
    }

    /**
     * Trata a exclusão de uma questão
     * @param {QuestionarioQuestao} questao Objeto com os dados da questão excluída
     */
    handleQuestaoDelete(questao) {
        //Copia a seção
        const secao = QuestionarioSecao.clone(this.props.secao);
        //Retorna a lista sem a questão excluída
        secao.questoes = secao.questoes.filter(q => q.ordem !== questao.ordem);
        //Dispara o evento de alteração
        this.dispararEventoOnChange(secao);
    }

    /**
     * Trata o evento de movimentação da questão para cima
     * @param {QuestionarioQuestao} questao Objeto com os dados da questão a ser movimentada
     */
    handleQuestaoMoveUp(questao) {
        //Copia a seção
        let secao = QuestionarioSecao.clone(this.props.secao);
        //Identifica o índice da questão alterada
        const indice = secao.questoes.findIndex(q => q.ordem === questao.ordem);
        //Verifica se já não é a primeira
        if (indice > 0) {
            //Troca a posição da questão com a anterior
            secao = this.trocarQuestoes(secao, indice, indice - 1);
            //Dispara o evento de alteração
            this.dispararEventoOnChange(secao);
        }
    }

    /**
     * Trata o evento de movimentação da questão para baixo
     * @param {QuestionarioQuestao} questao Objeto com os dados da questão a ser movimentada
     */
    handleQuestaoMoveDown(questao) {
        //Copia a seção
        let secao = QuestionarioSecao.clone(this.props.secao);
        //Identifica o índice da questão alterada
        const indice = secao.questoes.findIndex(q => q.ordem === questao.ordem);
        //Verifica se já não é a última
        if (indice < secao.questoes.length - 1) {
            //Troca a posição da questão com a posterior
            secao = this.trocarQuestoes(secao, indice, indice + 1);
            //Dispara o evento de alteração
            this.dispararEventoOnChange(secao);
        }
    }

    /**
     * Trata o acionamento do botão para adicionar questões
     */
    handleAdicionarQuestao() {
        //Copia a seção
        const secao = QuestionarioSecao.clone(this.props.secao);
        //Identifica o último ID inserido
        let ultimaOrdem = 0;
        if (secao.questoes.length > 0)
            ultimaOrdem = Math.max(...secao.questoes.map(r => r.ordem));

        //Inicializa uma nova questão
        const questao = new QuestionarioQuestao(null, '', false, false, '', ultimaOrdem + 1, false);
        questao.opcoes = [ new QuestionarioOpcaoResposta() ];
        //Adiciona uma a questão na lista
        secao.questoes.push(questao);
        //Dispara o evento de alteração
        this.dispararEventoOnChange(secao);
    }

    /**
     * Trata a escolha do usuário no dialog de confirmação
     * @param {Boolean} confirmacao Indica se o usuário confirmou a exclusão
     */
    handleDialogClose(confirmacao) {
        if (confirmacao) {
            //Dispara o evento de exclusão
            this.dispararEventoOnDelete(this.props.secao);
        } else {
            //Fecha o dialog
            this.setState({ confirmarExclusao: false });
        }
    }

    /**
     * Dispara o evento onChange, atualizando os dados no componente superior
     * @param {QuestionarioSecao} secao Dados da seção atual
     */
    dispararEventoOnChange(secao) {
        //Verifica se não é somente leitura e se o evento foi definido antes de chamar
        if (!this.props.readOnly && this.props.onChange)
            this.props.onChange(secao);
    }

    /**
     * Dispara o evento onDelete, indicando que ela deve ser excluída
     * @param {QuestionarioSecao} secao Objeto com os dados da seção excluída
     */
    dispararEventoOnDelete(secao) {
        //Verifica se o evento foi definido antes de chamar
        if (this.props.onDelete)
            this.props.onDelete(secao);
    }

    /**
     * Dispara o evento onMoveUp, indicando que a seção deve ser movida para cima
     * @param {QuestionarioSecao} secao Objeto com os dados da seção movida
     */
    dispararEventoOnMoveUp(secao) {
        //Verifica se o evento foi definido antes de chamar
        if (this.props.onMoveUp)
            this.props.onMoveUp(secao);
    }

    /**
     * Dispara o evento onMoveDown, indicando que a seção deve ser movida para baixo
     * @param {QuestionarioSecao} secao Objeto com os dados da seção movida
     */
    dispararEventoOnMoveDown(secao) {
        //Verifica se o evento foi definido antes de chamar
        if (this.props.onMoveDown)
            this.props.onMoveDown(secao);
    }

    /**
     * Troca a posição de duas questões na lista da seção
     * @param {QuestionarioSecao} secao Objeto contendo os dados da seção
     * @param {Number} indice1 Um dos índices a ser trocado
     * @param {Number} indice2 Outro índice a ser trocado
     * @returns {QuestionarioSecao} Retorna a seção alterada 
     */
    trocarQuestoes(secao, indice1, indice2) {
        const q1 = secao.questoes[indice1];
        const q2 = secao.questoes[indice2];
        secao.questoes[indice2] = q1;
        secao.questoes[indice1] = q2;   
        return secao;
    }

    /**
     * Renderiza o corpo da seção, de acordo com a indicação
     * @param {QuestionarioSecao} secao Dados da seção a ser renderizada
     * @param {ErroQuestionarioSecao} erros Erros da seção renderizada
     * @param {Boolean} open Indica se o corpo deve ser exibido ou não
     */
    renderizarCorpo(secao, erros, open) {
        if (open) {
            return (
                <React.Fragment>
                    {
                        secao.questoes.map((questao, indice) => (
                            <Questao 
                                key={questao.ordem} 
                                questao={questao} 
                                erros={erros.questoes[indice]}
                                focoAutomatico={this.props.focoAutomatico}
                                readOnly={this.props.readOnly}
                                onChange={this.handleQuestaoChange} 
                                onDelete={this.handleQuestaoDelete} 
                                onMoveUp={this.handleQuestaoMoveUp}
                                onMoveDown={this.handleQuestaoMoveDown}
                            />
                        ))
                    }
                    {
                        !this.props.readOnly &&
                            <Button 
                                id="adicionar-questao"
                                startIcon={<AddIcon />}
                                fullWidth 
                                color="primary"
                                onClick={this.handleAdicionarQuestao}
                            >
                                Adicionar questão
                            </Button>
                    }
                </React.Fragment>
            );
        }
    }

    /**
     * Renderiza a mensagem de erro referete à lista de questões
     * @param {ErroQuestionarioSecao} erros Mensagens de erro da seção
     */
    renderizarMesagemErro(erros) {
        if (erros.erroQuestoes) {
            return (
                <Grid item xs >
                    <FormHelperText error={!!erros.erroQuestoes}>{erros.erroQuestoes}</FormHelperText>
                </Grid>
            );
        }
    }

    shouldComponentUpdate(nextProps, nextState) {
        //Renderiza novamente se alguma das propriedades for diferente
        return nextState.open !== this.state.open 
            || nextState.confirmarExclusao !== this.state.confirmarExclusao 
            || !ErroQuestionarioSecao.compare(nextProps.erros, this.props.erros)
            || !QuestionarioSecao.compare(nextProps.secao, this.props.secao);
    }

    render() {
        const { secao, erros, classes, readOnly } = this.props;
        const { open, confirmarExclusao } = this.state;

        return (
            <React.Fragment>
                <VitalizePaper className={classes.tituloSecao} >
                    <Grid container spacing={1} >
                        <Grid item xs >
                            <TextField 
                                name="titulo" 
                                label="Seção" 
                                type="text" 
                                placeholder="Título da seção" 
                                required
                                variant="outlined" 
                                helperText={erros.titulo}
                                error={!!erros.titulo}
                                fullWidth 
                                autoFocus={this.props.focoAutomatico}
                                value={secao.titulo} 
                                onChange={this.handleChange} 
                            />
                        </Grid>
                        <Grid item xs="auto" >
                            <IconButton color="primary" id="ocultar-secao" size="small" onClick={this.handleOcultarClick} tabIndex={-1} >
                                { open ? <ExpandLess /> : <ExpandMore /> }
                            </IconButton>
                            {
                                !readOnly && (
                                    <Fragment>
                                        <IconButton color="primary" id="mover-secao-acima" size="small" onClick={this.handleUpClick} tabIndex={-1} >
                                            <ArrowUpwardIcon />
                                        </IconButton>
                                        <IconButton color="primary" id="mover-secao-abaixo" size="small" onClick={this.handleDownClick} tabIndex={-1} >
                                            <ArrowDownwardIcon />
                                        </IconButton>
                                        <IconButton color="primary" id="excluir-secao" size="small" onClick={this.handleDeleteClick} tabIndex={-1} >
                                            <DeleteIcon />
                                        </IconButton>
                                    </Fragment>
                                )
                            }

                        </Grid>
                    </Grid>
                    { this.renderizarMesagemErro(erros) }
                </VitalizePaper>
                { this.renderizarCorpo(secao, erros, open) }
                <ConfirmDialog titulo="Deseja excluir essa seção?" open={confirmarExclusao} onClose={this.handleDialogClose} />
            </React.Fragment>
        );
    }
}

Secao.propTypes = {
    /** Dados da seção */
    secao: PropTypes.instanceOf(QuestionarioSecao).isRequired,
    /** Mensagens de erro da seção */
    erros: PropTypes.instanceOf(ErroQuestionarioSecao),
    /** Indica se o componente terá o foco ao ser criado */
    focoAutomatico: PropTypes.bool,
    /** Identifica se o componente é somente leitura e não permite alterações */
    readOnly: PropTypes.bool,
    /** Evento disparado quando alguma informação é alterada */
    onChange: PropTypes.func,
    /** Evento disparado quando a seção é alterada */
    onDelete: PropTypes.func,
    /** Evento disparado quando o botão de mover acima é presionado */
    onMoveUp: PropTypes.func,
    /** Evento disparado quando o botão de mover abaixo é presionado */
    onMoveDown: PropTypes.func,
    /** Classes CSS */
    classes: PropTypes.shape({
        tituloSecao: PropTypes.string
    }),
};

Secao.defaultProps = {
    erros: new ErroQuestionarioSecao(),
    readOnly: false
};

export default withStyles(styles)(Secao);